<template>
  <profile v-if="options.length > 1" class="devices" :options="options">
    <slot />
  </profile>
  <default v-else>
    <div class="page page--profile mainWrap my-5">
      <div class="row">
        <div class="col-12">
          <slot />
        </div>
      </div>
    </div>
  </default>
</template>

<script lang="ts" setup>
import Profile from "~/components/shared/layout/profile.vue";
import { useUserStore } from "~/stores/userstore";
import { useDevicesStore } from "~/stores/devicesstore";
import Default from "~/layouts/default.vue";
import { PhCpu, PhCertificate, PhUsers } from "@phosphor-icons/vue";

const userStore = useUserStore();
const devicesStore = useDevicesStore();

const options = computed(() => {
  const baseOptions = [
    {
      name:
        "My Devices " +
        (devicesStore.deviceCounts
          ? "(" + devicesStore.deviceCounts?.myDevicesCount + ")"
          : ""),
      link: "/devices/my-devices",
      icon: PhCpu,
    },
  ];

  if (userStore.authUser?.companyId) {
    baseOptions.push({
      name:
        "Company Devices " +
        (devicesStore.deviceCounts
          ? "(" + devicesStore.deviceCounts?.companyDevicesCount + ")"
          : ""),
      link: "/devices/company-devices",
      icon: PhCertificate,
    });
  }

  if (userStore.isCompanyAdmin) {
    baseOptions.push({
      name:
        "Member Devices " +
        (devicesStore.deviceCounts
          ? "(" + devicesStore.deviceCounts?.memberDevicesCount + ")"
          : ""),
      link: "/devices/member-devices",
      icon: PhUsers,
    });
  }

  return baseOptions;
});

onMounted(async () => {
  await devicesStore.loadDevicesCount();
});
</script>
<!-- does not work with scoped because the template is defined in profile.vue layout -->
<style lang="scss">
@use "@/sass/layouts/Devices.scss" as *;
</style>
